import { get } from "services/httpService";

const SERVICE_URLS = {
  getStockDetails: (symbol) => `data/news_v2/${symbol}`,
  getDetailedSentiment: (symbol) => `data/detailed-sentiment/${symbol}`,
  getRisksChallenges: (symbol) => `data/risks-challenges/${symbol}`,
  getFinancialHealth: (symbol) => `data/financial-health/${symbol}`,
  getCategorizedNews: (symbol) => `data/categorized-news/${symbol}`,
  getStocks: () => `/dynamic-json-schema?type=ASSETS`,
  getExploreStocks: () => `/datadashboard/stock-search`,
  getStockInsideTrades: (symbol) => `data/insiders/${symbol}`,
  getStockCongressionalTrades: (symbol) => `data/congress/${symbol}`,
  getStockMovers: () => `/datadashboard/stock-movers`,
  getStockStrategies: (symbol) => `data/asset/strategy/?asset=${symbol}`,
  getStockPrice: (symbol) => `datadashboard/price-change?name=${symbol}`,
  getStockMetrics: (symbol) => `datadashboard/stock-details/?symbol=${symbol}`,
  getChartFetchData: () => `/datadashboard/data-fetch/`,
  getChartFetchEconomicData: () => `/datadashboard/economic-data/`,
  getDailyNews: () => `/news/daily`,
};

export const getStockDetails = (symbol) => {
  const _symbol = symbol.split(":")[1] || symbol;
  return get(SERVICE_URLS.getStockDetails(_symbol));
};

export const getDetailedSentiment = (symbol) => {
  const _symbol = symbol.split(":")[1] || symbol;
  return get(SERVICE_URLS.getDetailedSentiment(_symbol));
};

export const getRisksChallenges = (symbol) => {
  const _symbol = symbol.split(":")[1] || symbol;
  return get(SERVICE_URLS.getRisksChallenges(_symbol));
};

export const getFinancialHealth = (symbol) => {
  const _symbol = symbol.split(":")[1] || symbol;
  return get(SERVICE_URLS.getFinancialHealth(_symbol));
};

export const getCategorizedNews = (symbol) => {
  const _symbol = symbol.split(":")[1] || symbol;
  return get(SERVICE_URLS.getCategorizedNews(_symbol));
};

export const getStocks = () => get(SERVICE_URLS.getStocks());

export const getStockInsideTrades = (symbol) => {
  const _symbol = symbol.split(":")[1] || symbol;
  return get(SERVICE_URLS.getStockInsideTrades(_symbol));
};

export const getStockCongressionalTrades = (symbol) => {
  const _symbol = symbol.split(":")[1] || symbol;
  return get(SERVICE_URLS.getStockCongressionalTrades(_symbol));
};

export const getExploreStocks = (params) =>
  get(SERVICE_URLS.getExploreStocks(), params);

export const getStockMovers = (params) =>
  get(SERVICE_URLS.getStockMovers(), params);

export const getStockStrategies = (symbol) => {
  const _symbol = symbol.split(":")[1] || symbol;
  return get(SERVICE_URLS.getStockStrategies(_symbol));
};

export const getStockPrice = (name) => get(SERVICE_URLS.getStockPrice(name));

export const getChartFetchData = (params) =>
  get(SERVICE_URLS.getChartFetchData(), params);

export const getStockMetrics = (symbol) => {
  const _symbol = symbol.split(":")[1] || symbol;
  return get(SERVICE_URLS.getStockMetrics(_symbol));
};

export const getChartFetchEconomicData = (params) =>
  get(SERVICE_URLS.getChartFetchEconomicData(), params);

export const getDailyNews = (page = 0, strategyId) =>
  get(SERVICE_URLS.getDailyNews(), {
    page,
    ...(strategyId ? { strategy_id: strategyId } : {}),
  });
